import { render } from "./ListProfiles.vue?vue&type=template&id=44197296"
import script from "./ListProfiles.vue?vue&type=script&lang=js"
export * from "./ListProfiles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__